import { Model, Factory, belongsTo } from 'miragejs'
import type { ModelDefinition } from 'miragejs/-types'
import {
  randCatchPhrase,
  randChanceBoolean,
  randPastDate,
  randRecentDate,
  rand,
} from '@ngneat/falso'

import { filterable, pageable } from './utils.js'
import type { MockServer, MirageServer } from './server.js'
import type { SchemaAttributes } from '../types.js'

export type FormTemplateData = SchemaAttributes<'FormTemplate'>

export const model = (Model as ModelDefinition<FormTemplateData>).extend({
  department: belongsTo('department'),
  createdDepartment: belongsTo('department'),
})

export const factory = Factory.extend<FormTemplateData>({
  name() {
    return randCatchPhrase()
  },
  template_type() {
    return rand(['BUILD', 'DOCUMENT', 'PDF', 'ESIGNATURE'])
  },
  context() {
    return rand([
      'patient',
      'client',
      'consultation',
      'discharge_note',
      'patient_referral_feedback',
      'medicine',
      'general',
      'department',
      'invoice',
      'veterinarian',
    ])
  },
  archived() {
    return randChanceBoolean({ chanceTrue: 0.1 })
  },
  created() {
    return randPastDate({ years: 1 }).toISOString()
  },
  modified() {
    return randRecentDate().toISOString()
  },
})

export function routes(server: MockServer) {
  server.get('/form_templates', function (this: MirageServer, schema, request) {
    const templates = schema.all('formTemplate')

    const filtered = filterable(templates, request, {
      search: (item, value) =>
        item.attrs.name?.toLowerCase().includes(value.toLowerCase()),
      context: (item, value) => item.attrs.context === value,
      template_type: (item, value) => item.attrs.template_type === value,
      'department.id': (item, value) => item.department?.id === value,
    })

    const { data, meta } = pageable(filtered, request)

    return {
      ...this.serialize(data),
      meta: {
        pagination: meta,
      },
    }
  })
}

export function seeds(server: MockServer) {
  server.schema.all('department').models.forEach((department) => {
    server.createList('formTemplate', 5, {
      context: 'consultation',
      template_type: 'PDF',
      archived: false,
      department,
    })
    server.createList('formTemplate', 3, {
      context: 'discharge_note',
      template_type: 'PDF',
      archived: false,
      department,
    })
  })
}
